

























































import Vue, { PropType } from 'vue';
import { Image, genDownloadOriginalImageUrlEx, uploadImageEx } from '@/modules/image';

export type DataType = {
  inputImageSrc: string;
  // uploadImage: Function;
  uploadedImageSrc: string;
  isDragOver: boolean;
};

export default Vue.extend({
  name: 'GImageCrop',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    name: {
      type: String as PropType<string>,
      default: '',
    },
    value: {
      type: Object as PropType<Image>,
      default: null,
    },
    error: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    aspect: {
      type: Number,
      default: null,
    },
    isCircle: {
      type: Boolean,
      default: false,
    },
    showDragOver: {
      type: Boolean,
      default: false,
    },
  },
  data(): DataType {
    return {
      inputImageSrc: '',
      uploadedImageSrc: '',
      // uploadImage: uploadImage,
      isDragOver: false,
    };
  },
  methods: {
    async setInitImage() {
      if (!this.value) return;
      if (!this.value.id) return;
      this.uploadedImageSrc = await genDownloadOriginalImageUrlEx(
        this.owner,
        this.value.id,
      );
    },
    setImage(e: any) {
      if (this.showDragOver) {
        this.dragFile(false);
      }
      const file = e.target.files[0];
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event: any) => {
          this.inputImageSrc = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    deleteImage() {
      this.uploadedImageSrc = '';
      this.inputImageSrc = '';
      this.$emit('input', null);
    },
    async setCropedImage(blob: Blob) {
      this.inputImageSrc = '';
      const image = await uploadImageEx(
        this.owner,
        // this.$auth.cid,
        blob,
        'name',
      );
      if (!image.id) {
        throw Error('Can not get image.id');
      }
      this.uploadedImageSrc = await genDownloadOriginalImageUrlEx(
        this.owner,
        // this.$auth.cid,
        image.id,
      );
      this.$emit('input', image);
    },
    cancelCrop() {
      this.inputImageSrc = '';
    },
    dragFile(result: boolean) {
      this.isDragOver = result;
    },
  },
  async mounted() {
    this.setInitImage();
  },
});
